import { render, staticRenderFns } from "./PoyntStoreId.vue?vue&type=template&id=4632a4a1&"
import script from "./PoyntStoreId.vue?vue&type=script&lang=ts&"
export * from "./PoyntStoreId.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports